export default "__VITE_ASSET__37_zOuR1__"